/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import * as React from 'react';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs as RNBreadcrumbs, Typography, Stack, Divider, Box } from '@mui/material';

import { COLOR } from '../../helpers/colors';
import i18n from '../../helpers/i18nMain';

export default function Breadcrumbs(props) {
  const pathnames = props.location.pathname.split('/').filter(x => x);
  const { showDivider = true } = props;
  return (
    <Box flex={1}>
      {props.data && props.data.length > 0 ? (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          sx={{ marginY: 2, marginX: 1 }}
        >
          <RNBreadcrumbs
            aria-label="breadcrumb"
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={{
                  fontSize: 14,
                  transform: i18n.dir() === 'rtl' ? 'rotate(-180deg)' : 'none',
                }}
              />
            }
          >
            {props.data.map((item, index) => (
              <Typography
                color="text.primary"
                key={index.toString()}
                onClick={() => props.history.push(item.path)}
                sx={{
                  fontSize: { xs: 14, sm: 15, md: 16 },
                  '&:hover': {
                    cursor: 'pointer',
                    color: COLOR.linkColor,
                  },
                }}
              >
                {item.name}
              </Typography>
            ))}
          </RNBreadcrumbs>
        </Stack>
      ) : (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          sx={{ marginY: 2, marginX: 1 }}
          flex={1}
        >
          <RNBreadcrumbs
            aria-label="breadcrumb"
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={{
                  fontSize: 14,
                  transform: i18n.dir() === 'rtl' ? 'rotate(-180deg)' : 'none',
                }}
              />
            }
          >
            <Typography
              color="text.primary"
              sx={{
                fontSize: { xs: 14, sm: 15, md: 16 },
                '&:hover': {
                  cursor: 'pointer',
                  color: COLOR.linkColor,
                },
              }}
              onClick={() => props.history.push('/')}
            >
              {i18n.t('libraryTranslations:HOME')}
            </Typography>

            <Typography
              color="text.primary"
              sx={{
                fontSize: { xs: 14, sm: 15, md: 16 },
                '&:hover': {
                  cursor: 'pointer',
                  color: COLOR.linkColor,
                },
              }}
            >
              {props.breadcrumbNameMap[`/${pathnames[0]}`]}
            </Typography>
          </RNBreadcrumbs>
        </Stack>
      )}
      {showDivider && <Divider />}
    </Box>
  );
}
